import React from "react";
import "./pending.css";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import $ from "jquery";
import API from "../../helpers/endpointservice";
import axios from "axios";
import WarningComponent from "../../helpers/modal";
import { toast } from "react-toastify";
import Toaster from "../../helpers/toaster";
import CommonIcon from "../../helpers/icons";
import PaginationComponent from "../../helpers/Pagination";
import moment from "moment";
import UserRole from "../../helpers/role";
import UserStatus from "../../helpers/status";
import Loader from "../../helpers/loader";
import SmallCanvas from "./SmallCanvas";
import BigCanvas from "./BigCanavas";
import DateFnsUtils from "@date-io/date-fns";
import Select from "react-select";
import { Navigate } from "react-router";
import { logoutFunction } from "../../custom/logoutFunction";
import FileIcon from "../../custom/FileIcon";
import swal from "sweetalert";
import { certificateUploadFormats } from "../../helpers/MediaFormats";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  }),
};
class PendingSubmissions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      sortBy: "trainingRequestId",
      isSortAscending: true,
      currentUser: [
        // "admin",
        // "gm",
        // "manager",
        // "supervisor",
        // "employee"
      ],
      isAgree: false, //LOU
      isDontAgree: false,
      isSubmissionFailed: false,
      isSubmissionLoader: false,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      isSMobile: false,
      isSearch: false,
      validationMsg: false,
      uploadedFileName: "",
      TrainingBondComments: "",
      trainingRequestId: 0,
      isFileEmpty: false,
      trainingBondFormData: "",
      isPdf: false,
      pendingStatus: "",
      certificateEndDate: "",
      courseQuestionaire: [],
      LouDetails: [],
      postLOUAnswers: [],
      postCourseAnswers: [],
      pendingApprovalsList: [],
      employeeNameEmpty: false,
      selectEmployeeName: [],
      employeeNameList: [],
      searchInputData: {
        trainingRequestId: "",
        employeeCode: "",
        employeeName: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        currentStatus: "",
      },
      pendingApprovalsView: {
        id: 0,
        courseCode: "",
        courseTitle: "",
        currentStatus: "",
        pendingStatus: "",
        employeeCode: null,
        employeeGuid: null,
        employeeName: "",
        employeeuserId: 0,
        requestedBy: null,
        requestedDate: null,
        trainingRequestId: 0,
        status: "",
        statusId: 0,
        comments: "",
        fileUrl: "",
        reviewerId: 0,
        trainingBond: {
          fileId: 0,
          fileName: "",
        },
        certificate: {
          fileId: 0,
          fileName: "",
        },
        trainingStatusId: 0,
        trainingRequestorId: 0,

        //PTE Details
        pte: [
          {
            trainingRequestId: 0,
            questionId: 0,
            question: "",
            ptE1AnswerId: 0,
            ptE1Answer: "",
            ptE2AnswerId: 0,
            ptE2Answer: "",
            ptE3AnswerId: 0,
            ptE3Answer: "",
          },
        ],
        pteEvaluation: [],
        pteJobEvaluation: [],
        evaluationAns: [],
        skillStatus: [],
        CourseQuestAnswers: [],
      },
      currentPage: 1,
      perPage: 20,
      totalCount: 20,
      requestCount: 0,
      pageNewCount: false,
      historyLogList: [],
      documentsList: [],
      UserId: 0,
      pteRadioAns: [],
      ApprovalList: {
        trainingRequestId: 0,
        comments: "",
      },
      navigate: false,
      validateComments: false,
      inputValues: [],
      pendingTaskHeading: "",
      certificateExpiryDateApproval: null,
    };
    this.focusRef = React.createRef();
    this.smallfocusRef = React.createRef();
    this.trainingBondRef = React.createRef();
    this.certificateRef = React.createRef();
  }

  handleDateChange(e) {
    let reqDate = new Date(e);
    this.setState({
      ...this.state,
      certificateExpiryDateApproval: reqDate,
    });
  }

  AttachFiles = () => {
    this.trainingBondRef.current.click();
  };

  componentDidMount() {
    let user = localStorage.getItem("UserId");
    let value = localStorage.getItem("Role");
    this.state.UserId = user;
    this.state.currentUser = value; //Change
    this.setState({}, () => {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );
    });
    $("body").removeClass("scrollhide");
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }
    if (window.innerWidth < 399) {
      this.state.isSMobile = true;
    } else {
      this.state.isSMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  //Fetching Pending Approval List data (GET)
  // GetMyPendingApprovalsList = async (currentPage, perPage) => {
  //   const { sortBy, UserId,pendingApprovalsList,pendingApprovalsView } = this.state;
  //   let order = this.state.order === 'asc' ? true : false;
  //   let apiUrl = `${API.GET_PENDING_TASKS}?sortBy=${sortBy}&isSortAscending=${order}&UserId=${UserId}&pageNumber=${parseInt(currentPage)}&pageSize=${parseInt(perPage)}`;
  //   this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
  //   let res = await this.updatePostFunction(apiUrl);
  //   if (res.status === 200) {
  //     this.setState({ pendingApprovalsList: res.data.data.values, totalCount: res.data.data.totalCount, isSubmissionLoader: false, isSubmissionFailed: false });
  //   }
  // };

  GetMyPendingApprovalsList = (currentPage, perPage) => {
    const { sortBy, UserId, isSearch, searchInputData } = this.state;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${
      API.GET_PENDING_TASKS
    }?sortBy=${sortBy}&isSortAscending=${order}&UserId=${UserId}&pageNumber=${parseInt(
      currentPage
    )}&pageSize=${parseInt(perPage)}`;
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    let searchValues = {
      requestId: searchInputData.trainingRequestId || null,
      employeeCode: searchInputData.employeeCode || null,
      employeeName: this.state.selectEmployeeName?.value?.split(",")[2] || null,
      courseCode: searchInputData.courseCode || null,
      courseTitle: searchInputData.courseTitle || null,
      currentStatus: searchInputData.currentStatus || null,
      requestedDate:
        searchInputData.requestedDate?.toISOString()?.slice(0, 10) || null,
    };
    axios({
      method: "POST",
      url: apiUrl,
      data: isSearch === true ? searchValues : {},
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            pendingApprovalsList: res.data.values,
            totalCount: res.data.totalCount,
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isSubmissionLoader: false,
          isSubmissionFailed: false,
          isSearch: false,
        });
        logoutFunction(error?.response?.status);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  // Pagination

  // handlePageChange = (pageNumber) => {
  //   this.setState(
  //     { currentPage: pageNumber },
  //     () => {
  //       this.fetchPaginationList(pageNumber, this.state.perPage); //pageSize
  //     }
  //   );
  // };

  fetchPaginationList = (currentpage, perpage) => {
    this.setState(
      {
        currentPage: currentpage,
        perPage: perpage,
        isSortAscending: this.state.isSortAscending,
        sortBy: this.state.sortBy,
      },
      () => {
        this.GetMyPendingApprovalsList(currentpage, perpage);
      }
    );
  };

  //End Pagination

  //HistoryLog
  GetHistoryLogList = async (trainingRequestId) => {
    let apiUrl = `${API.GET_HISTORY_LOG}?trainingRequestId=${trainingRequestId}`;
    // this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    let res = await this.updateGetFunction(apiUrl);
    if (res.status === 200) {
      this.setState({
        historyLogList: res.data,
      });
    }
  };

  //Sorting Process
  sortTable = (name) => {
    let sortData = this.state.pendingApprovalsList;
    if (sortData?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }

      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState(
        {
          currentPage: 1,
        },
        () => {
          this.GetMyPendingApprovalsList(
            this.state.currentPage,
            this.state.perPage
          );
        }
      );
    }
  };

  //Big Screen
  pteScreen = () => {
    $("#bigCanvas").scrollTop(0);
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pteScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };
  //Small Screen
  propertiesScreen = () => {
    $("#smallCanvas").scrollTop(0);
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  CertificateScreen = () => {
    $("#certificateCanvas").scrollTop(0);
    // let myOffcanvas = new window.bootstrap.Offcanvas(
    //   document.getElementById("certificateUploadScreen")
    // );
    // myOffcanvas.show();
    $("#certificateUploadScreen").removeClass("visible-hide");
    $("#certificateUploadScreen").addClass("visible-show");
    $("body").addClass("scrollhide");
  };

  openSearch = () => {
    // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("searchScreen"));
    // myOffcanvas.show();
    $("#searchScreen").removeClass("display-hide");
    $("#searchScreen").addClass("visible-show");
    $("body").addClass("scrollhide");
    this.state.currentUser?.includes(UserRole.ADMIN)
      ? this.GetEmployeeListAdmin()
      : this.getEmployeeName();
  };

  getEmployeeName = async () => {
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    const { UserId, employeeNameList } = this.state;
    let apiUrl = `${API.GET_EMPLOYEES}?userId=${UserId}`;
    let res = await this.updateGetFunction(apiUrl);
    if (res.status === 200) {
      this.state.employeeNameList = res?.data?.map((employee) => {
        return {
          value:
            employee.employeeId +
            "," +
            employee.employeeCode +
            "," +
            employee.employeeName,
          label: (
            <>
              <span>{employee.employeeName}</span>
            </>
          ),
        };
      });
      this.setState({
        isSubmissionFailed: false,
        isSubmissionLoader: false,
      });
    }
  };

  GetEmployeeListAdmin = async (trainingId) => {
    let apiUrl = `${API.GET_ADMIN_EMPLOYEE_LIST}`;
    let res = await this.updateGetFunction(apiUrl);
    if (res.status === 200) {
      this.state.employeeNameList = res?.data?.map((employee) => {
        return {
          value:
            employee.id + "," + employee.employeeCode + "," + employee.userName,
          label: (
            <>
              <span>{employee.userName}</span>
            </>
          ),
        };
      });
      this.setState({
        isSubmissionFailed: false,
        isSubmissionLoader: false,
      });
    }
  };

  clearSearchProperties = () => {
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
    this.setState({
      validationMsg: false,
    });
  };

  clearSearchDetails = () => {
    this.setState({
      searchInputData: {
        trainingRequestId: "",
        employeeCode: "",
        employeeName: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        currentStatus: "",
      },
      selectEmployeeName: [],
      isSearch: false,
      currentPage: 1,
      pageNewCount: !this.state.pageNewCount,
      validationMsg: false,
    });

    this.setState({}, () =>
      this.GetMyPendingApprovalsList(this.state.currentPage, this.state.perPage)
    );
    $("#propertiesScreen").removeClass("show");
    $("#certificateUploadScreen").addClass("visible-hide");
    $("#certificateUploadScreen").removeClass("visible-show");

    $("#pteScreen").removeClass("show");
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  handleInputchange(e, field) {
    if (field === "requestedDate") {
      let reqDate = new Date(e);
      this.state.searchInputData[field] = reqDate;
    } else {
      this.state.searchInputData[field] = e.target.value;
    }
    this.setState({});
  }

  onchangeEmployeeName = (e, field) => {
    if (this.state.currentUser?.includes(UserRole.ADMIN)) {
      if (e === null) {
        this.state.employeeId = "";
        this.state.employeeCode = "";
        this.state.employeeName = "";
        this.state.selectEmployee = [];
        this.state.selectEmployeeName = [];
        this.state.searchInputData[field] = "";
        this.setState({});
      } else {
        this.state.employeeId = parseInt(e.value.split(",")[0]);
        this.state.employeeCode = e.value.split(",")[1];
        this.state.employeeName = e.value.split(",")[2];
        this.state.selectEmployee = e;
        this.state.searchInputData[field] = e.value;
        this.state.selectEmployeeName = e;
        this.setState({});
      }
    } else {
      if (e === null) {
        this.state.searchInputData[field] = "";
        this.state.selectEmployeeName = [];
        this.setState({});
      } else {
        this.state.searchInputData[field] = e.label;
        this.state.selectEmployeeName = e;
        this.setState({});
      }
    }
  };
  // handleEmployeeChange = (e) => {
  //   if (e === null) {
  //     this.state.employeeId = "";
  //     this.state.employeeCode = "";
  //     this.state.employeeName = "";
  //     this.state.selectEmployee = [];
  //     this.setState({});
  //   } else {
  //     this.state.employeeId = parseInt(e.value.split(",")[0]);
  //     this.state.employeeCode = e.value.split(",")[1];
  //     this.state.employeeName = e.value.split(",")[2];
  //     this.state.selectEmployee = e;
  //     this.setState({});
  //   }
  // };

  validateSearchRecords = () => {
    const inputs = document.querySelectorAll(
      ".records-editinput-class[required]"
    );
    const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
    const isValid1 =
      this.state.selectEmployeeName?.length !== 0 ||
      this.state.searchInputData.requestedDate;

    if (isValid || isValid1) {
      this.submitSearchDetails();
      this.setState({
        validationMsg: false,
      });
    } else {
      this.setState({
        validationMsg: true,
      });
    }
  };

  submitSearchDetails = () => {
    // this.setState({ isSearch: true })
    this.state.isSearch = true;
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState({}, () =>
      this.GetMyPendingApprovalsList(this.state.currentPage, this.state.perPage)
    );
    $("#propertiesScreen").removeClass("show");
    $("#pteScreen").removeClass("show");
    $("#certificateUploadScreen").addClass("visible-hide");
    $("#certificateUploadScreen").removeClass("visible-show");

    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");

    $("body").removeClass("scrollhide");
  };

  //Screen Assignments
  MyPendingSubmission = (trainingRequestId, status, heading) => {
    this.ShowPendingSubmissionById(trainingRequestId, status, heading);
    this.state.pendingStatus = status?.toLowerCase()?.replace(/\s+/g, "");
    this.state.trainingRequestId = trainingRequestId; //trainingRequestId
    if (
      status === UserStatus.PENDING_FOR_APPROVAL ||
      status === UserStatus.PENDING_FOR_ADMIN_APPROVAL ||
      status === UserStatus.PENDING_FOR_GM_APPROVAL ||
      status === UserStatus.PENDING_FOR_MANAGER_APPROVAL ||
      status === UserStatus.PENDING_FOR_SUPERVISOR_APPROVAL
    ) {
      // this.propertiesScreen();
      this.GetHistoryLogList(trainingRequestId);
    } else if (status === UserStatus.PENDING_TRAIN_BOND) {
      // this.propertiesScreen();
      this.GetHistoryLogList(trainingRequestId);
    } else if (
      status === UserStatus.PENDING_FOR_CERT ||
      status === UserStatus.PENDING_FOR_COURSE_COMPLETION
    ) {
      // this.propertiesScreen();
      this.GetHistoryLogList(trainingRequestId);
    } else if (status === UserStatus.PENDING_CERT_UPLOAD) {
      // this.CertificateScreen();
      this.GetHistoryLogList(trainingRequestId);
    } else if (
      status === UserStatus.PENDING_FOR_LOU ||
      status === UserStatus.PENDING_FOR_COURSE_QUESTIONNAIRE ||
      status === UserStatus.PENDING_REVIEW_COURSE_QUESTIONNAIRE
    ) {
      // this.pteScreen();
      this.GetCourseQuestionaireDetails(status);
      this.GetLouDetails();
      this.SkillsData();
      this.JobsData();
      this.CourseQuestAnswers();
      this.GetHistoryLogList(trainingRequestId);
    } else if (
      status === UserStatus.PENDING_FOR_PTE1_APPROVAL ||
      status === UserStatus.PENDING_FOR_PTE2_APPROVAL ||
      status === UserStatus.PENDING_FOR_PTE3_APPROVAL ||
      status === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE ||
      status === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE ||
      status === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE ||
      status === UserStatus.PTE1_UPDATE ||
      status === UserStatus.PTE2_UPDATE ||
      status === UserStatus.PTE3_UPDATE ||
      status === UserStatus.PTE1_REWORK ||
      status === UserStatus.PTE2_REWORK ||
      status === UserStatus.PTE3_REWORK
    ) {
      this.SkillsData();
      this.JobsData();
      this.getPteQuestionDetails();
      // this.pteScreen();
      this.GetHistoryLogList(trainingRequestId);
    }
  };

  clearAllData = () => {
    this.setState({
      uploadedFileName: "",
      fileExtension: "",
      ApprovalList: {},
      TrainingBondComments: "",
      pendingApprovalsView: {},
      isFileEmpty: false,
      isPdf: false,
      trainingBondFormData: "",
      certificateEndDate: "",
      postLOUAnswers: [],
      postCourseAnswers: [],
      isAgree: false,
      isDontAgree: false,
      // isSearch: false,
      validationMsg: false,
      validateComments: false,
      // employeeNameList: [],
      // selectEmployeeName: [],
      inputValues: [],
      postLOUAnswers: [],
      pteRadioAns: [],
    });
    const inputElements = document.getElementsByName("louName");
    for (let i = 0; i < inputElements.length; i++) {
      inputElements[i].value = "";
    }
  };

  closeProperties = () => {
    $("#propertiesScreen").removeClass("show");
    $("#pteScreen").removeClass("show");
    $("#certificateUploadScreen").removeClass("visible-show");
    $("#certificateUploadScreen").addClass("visible-hide");
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
    this.state.order = "asc";
    this.clearAllData();
  };

  RejectToast = () => {
    if (this.state.TrainingBondComments !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("CancelCourseScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");

      // this.focusRef.current.focus();
    } else {
      // document.getElementById('small_Comments').focus();
      this.focusRef.current.focus();
      this.smallfocusRef?.current?.focus();
      // this.focusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.setState({
        validateComments: true,
      });
    }
  };

  ///////////////////////////////////// Pending for Apporval  ///////////////////////////////////////////

  //Common POST API call Function
  // updatePostFunction = async (uri, values) => {
  //   // Send the request and return the response as a Promise.
  //   const response = axios({
  //     method: "POST",
  //     url: uri,
  //     data: values,
  //   })
  //   return response.then((res) => {
  //     let response = {
  //       ok: true,
  //       status: 200,
  //       statusText: 'success',
  //       data: res,
  //       error: undefined,
  //       type: 'retrieve',
  //       url: uri
  //     }
  //     return response;
  //   }, (err) => {
  //     let response = {
  //       ok: false,
  //       status: err.status,
  //       statusText: err.statusText,
  //       error: err.responseJSON.message,
  //       type: 'retrieve',
  //       url: uri
  //     }
  //     return response;
  //   });

  // };

  updatePostFunction = async (uri, values) => {
    try {
      // Send the request and await the response.
      const response = await axios({
        method: "POST",
        url: uri,
        data: values,
      });

      // Create and return the success response object.
      let responseData = {
        ok: true,
        status: 200,
        statusText: "success",
        data: response.data,
        error: undefined,
        type: "retrieve",
        url: uri,
      };
      return responseData;
    } catch (err) {
      // Create and return the error response object.
      let responseData = {
        ok: false,
        status: err.response.status,
        statusText: err.response.statusText,
        error: err.response.data.message,
        type: "retrieve",
        url: uri,
      };
      logoutFunction(err?.response?.status);
      this.setState({ isSubmissionLoader: false });
      // swal("Error!", "Something went wrong. Please try again.", "warning");
      return responseData;
    }
  };
  //Common Get API calls Function
  // updateGetFunction = async (uri) => {
  //   const response = axios({
  //     method: "GET",
  //     url: uri,
  //   })
  //   return response.then((res) => {
  //     let response = {
  //       ok: true,
  //       status: 200,
  //       statusText: 'success',
  //       data: res,
  //       error: undefined,
  //       type: 'retrieve',
  //       url: uri
  //     }
  //     return response;
  //   }, (err) => {
  //     let response = {
  //       ok: false,
  //       status: err.status,
  //       statusText: err.statusText,
  //       error: err.responseJSON.message,
  //       type: 'retrieve',
  //       url: uri
  //     }
  //     return response;
  //   });

  // }
  updateGetFunction = async (uri) => {
    try {
      const response = await axios({
        method: "GET",
        url: uri,
      });

      let responseData = {
        ok: true,
        status: 200,
        statusText: "success",
        data: response.data,
        error: undefined,
        type: "retrieve",
        url: uri,
      };

      return responseData;
    } catch (error) {
      let responseData = {
        ok: false,
        status: error.response?.status || 500,
        statusText: error.response?.statusText || "Internal Server Error",
        error: error.response?.data?.message || "Unknown Error",
        type: "retrieve",
        url: uri,
      };
      logoutFunction(error?.response?.status);
      this.setState({ isSubmissionLoader: false });
      // swal("Error!", "Something went wrong. Please try again.", "warning");
      return responseData;
    }
  };

  //Handle Reject function
  handleReject = async () => {
    const { UserId, pendingApprovalsView, TrainingBondComments } = this.state;
    if (TrainingBondComments !== "") {
      let apiurl = `${API.GET_REJECT_TRAINING}?UserId=${UserId}`;

      let ApprovalList = {
        trainingRequestId: this.state.trainingRequestId,
        comments: TrainingBondComments,
      };
      this.setState({
        isSubmissionLoader: true,
        isSubmissionFailed: false,
      });

      let res = await this.updatePostFunction(apiurl, ApprovalList);
      if (res.status === 200) {
        this.GetMyPendingApprovalsList(
          this.state.currentPage,
          this.state.perPage
        );
        // this.RejectToast();
        toast.success("Request rejected successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
      } else {
        swal(
          "Error when rejecting the request",
          "Please try again.",
          "warning"
        );
      }
    } else {
      this.setState({
        validateComments: true,
      });
    }
  };

  handleCancel = async () => {
    const {
      UserId,
      pendingApprovalsView,
      trainingRequestId,
      TrainingBondComments,
    } = this.state;
    let apiurl = `${API.GET_CANCEL_TRAINING}?userId=${UserId}&trainingRequestId=${trainingRequestId}&comments=${TrainingBondComments}`;
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    let ApprovalList = [];
    // let ApprovalList = {
    //   trainingRequestId: this.state.trainingRequestId,
    //   comments : this.state.TrainingBondComments
    // }
    let res = await this.updatePostFunction(apiurl, ApprovalList);
    if (res.status === 200) {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );
      // this.RejectToast();
      toast.success("Request Cancelled successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      swal("Error when cancelling the request", "Please try again.", "warning");
    }
  };

  //Handle Approve function
  handleApprove = async () => {
    const {
      UserId,
      pendingApprovalsView,
      TrainingBondComments,
      pendingStatus,
    } = this.state;
    let apiurl = `${API.GET_APPROVE_TRAINING}?UserId=${UserId}`;
    let ApprovalList = {
      trainingRequestId: this.state.trainingRequestId,
      comments: TrainingBondComments,
    };
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    let res = await this.updatePostFunction(apiurl, ApprovalList);
    if (res.status === 200) {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );
      this.ApproveToast(pendingStatus);
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      this.ErrorToast(pendingStatus);
    }
  };

  //PTE Approve or Reject
  handlePteApprove = async (pteval) => {
    const {
      UserId,
      pendingApprovalsView,
      TrainingBondComments,
      pteRadioAns,
      pendingStatus,
    } = this.state;
    let apiurl = `${API.SUBMIT_PTE}?userId=${UserId}`;
    let apiurl1 = `${API.ACKNOWLEDGE_PTE}?userId=${UserId}`;
    let apiurl2 = `${API.APPROVE_PTE}?userId=${UserId}`;
    var pteApproveList;

    if (
      this.state.pendingStatus === UserStatus.PTE1_UPDATE ||
      this.state.pendingStatus === UserStatus.PTE2_UPDATE ||
      this.state.pendingStatus === UserStatus.PTE3_UPDATE
    ) {
      var totalLength =
        pendingApprovalsView.pteEvaluation?.length +
        (pendingApprovalsView.pteJobEvaluation?.length
          ? pendingApprovalsView.pteJobEvaluation?.length
          : 0);
      if (pteRadioAns?.length == totalLength) {
        if (
          pendingApprovalsView.pteJobEvaluation == null ||
          pendingApprovalsView.pteJobEvaluation == undefined ||
          pendingApprovalsView.pteJobEvaluation?.length !== 0
        ) {
          pendingApprovalsView.pteJobEvaluation = [];
        }
        var pteApproveList = {
          trainingRequestId: this.state.trainingRequestId,
          comments: TrainingBondComments,
          isApproveToPTE3: false,
          pteEvaluations: this.state.pendingStatus?.includes("update")
            ? pteRadioAns
            : [],
        };
        this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });

        let res = await this.updatePostFunction(apiurl, pteApproveList);
        if (res.status === 200) {
          this.setState({ pteRadioAns: [] });
          this.GetMyPendingApprovalsList(
            this.state.currentPage,
            this.state.perPage
          );
          this.ApproveToast(pendingStatus);
          this.setState({
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        } else {
          this.ErrorToast(pendingStatus);
        }
      } else {
        toast.error("Please give values", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      let reworkPtevalues = [];
      let reworkJobValues = [];

      if (
        pendingApprovalsView.pteJobEvaluation == null ||
        pendingApprovalsView.pteJobEvaluation == undefined ||
        pendingApprovalsView.pteJobEvaluation?.length === 0
      ) {
        pendingApprovalsView.pteJobEvaluation = [];
        reworkJobValues = [];
      }
      pendingApprovalsView.pteEvaluation?.map((item) => {
        reworkPtevalues = [
          ...reworkPtevalues,
          {
            questionId: item.questionId,
            question: item.question,
            answerId:
              (pendingStatus?.includes("1") && item.ptE1AnswerId) ||
              (pendingStatus?.includes("2") && item.ptE2AnswerId) ||
              (pendingStatus?.includes("3") && item.ptE3AnswerId),
            answer:
              (pendingStatus?.includes("1") && item.ptE1Answer) ||
              (pendingStatus?.includes("2") && item.ptE2Answer) ||
              (pendingStatus?.includes("3") && item.ptE3Answer),
          },
        ];
      });
      pendingApprovalsView.pteJobEvaluation?.map((item) => {
        reworkJobValues = [
          ...reworkJobValues,
          {
            questionId: item.questionId,
            question: item.question,
            answerId:
              (pendingStatus?.includes("1") && item.ptE1AnswerId) ||
              (pendingStatus?.includes("2") && item.ptE2AnswerId) ||
              (pendingStatus?.includes("3") && item.ptE3AnswerId),
            answer:
              (pendingStatus?.includes("1") && item.ptE1Answer) ||
              (pendingStatus?.includes("2") && item.ptE2Answer) ||
              (pendingStatus?.includes("3") && item.ptE3Answer),
          },
        ];
      });

      // var pteApproveList = {
      //   trainingRequestId: this.state.trainingRequestId,
      //   comments: TrainingBondComments,
      //   isApproveToPTE3: (pteval == "ApproveToPTE3") ? true : false,
      //   pteEvaluations: (this.state.pendingStatus?.includes("rework"))
      //     ? [...reworkPtevalues, ...reworkJobValues]
      //     : ((this.state.pendingStatus?.includes("approval")) || (this.state.pendingStatus?.includes("update"))) ? pteRadioAns : []
      // };
      var pteApproveList = {
        trainingRequestId: this.state.trainingRequestId,
        comments: TrainingBondComments,
        isApproveToPTE3: pteval == "ApproveToPTE3" ? true : false,
        pteEvaluations: this.state.pendingStatus?.includes("rework")
          ? [...reworkPtevalues, ...reworkJobValues]
          : this.state.pendingStatus?.includes("update")
          ? pteRadioAns
          : [],
      };

      this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });

      if (pteval === "Rework") {
        let res = await this.updatePostFunction(apiurl, pteApproveList);
        if (res.status === 200) {
          this.GetMyPendingApprovalsList(
            this.state.currentPage,
            this.state.perPage
          );
          this.ApproveToast(pendingStatus);
          this.setState({
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        } else {
          this.ErrorToast(pendingStatus);
        }
      } else if (pteval === "Acknowledge") {
        let res = await this.updatePostFunction(apiurl1, pteApproveList);
        if (res.status === 200) {
          this.GetMyPendingApprovalsList(
            this.state.currentPage,
            this.state.perPage
          );
          this.ApproveToast(pendingStatus);
          this.setState({
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        } else {
          this.ErrorToast(pendingStatus);
        }
      } else {
        let res = await this.updatePostFunction(apiurl2, pteApproveList);
        if (res.status === 200) {
          this.GetMyPendingApprovalsList(
            this.state.currentPage,
            this.state.perPage
          );
          this.ApproveToast(pendingStatus);
          this.setState({
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        } else {
          this.ErrorToast(pendingStatus);
        }
      }
    }
  };

  handlePteReject = async () => {
    const { UserId, pendingApprovalsView, TrainingBondComments, pteRadioAns } =
      this.state;
    let apiurl = `${API.REJECT_PTE}?userId=${UserId}`;
    let pteRejectList = {
      trainingRequestId: this.state.trainingRequestId,
      comments: TrainingBondComments,
      isApproveToPTE3: false,
      pteEvaluations: pteRadioAns, //  Ask.
    };
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });

    let res = await this.updatePostFunction(apiurl, pteRejectList);
    if (res.status === 200) {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );
      // this.RejectToast();
      toast.success(
        (this.state.pendingStatus?.includes("1") &&
          "PTE 1 rejected successfully") ||
          (this.state.pendingStatus?.includes("2") &&
            "PTE 2 rejected successfully") ||
          (this.state.pendingStatus?.includes("3") &&
            "PTE 3 rejected successfully"),
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      swal(
        (this.state.pendingStatus?.includes("1") &&
          "Error when rejecting the PTE1") ||
          (this.state.pendingStatus?.includes("2") &&
            "Error When rejecting the PTE2") ||
          (this.state.pendingStatus?.includes("3") &&
            "Error When rejecting the PTE3"),
        "Please try again.",
        "warning"
      );
    }
  };

  ///////////////////////////////////// End Pending for Apporval  ////////////////////////////////////////

  ////////////////////////////////////Getting PTE Details ///////////////////////////////////////////////

  getPteQuestionDetails = () => {
    let apiUrl = `${API.GET_PTE_BY_ID}?trainingrequestId=${this.state.trainingRequestId}`;
    axios
      .get(apiUrl)
      .then((res) => {
        if (res.status === 200) {
          const pteQuestions = res.data.pteQuestions?.map((item) => ({
            questionId: item.questionId,
            question: item.question,
            ptE1Answer: item.ptE1Answer,
            ptE1AnswerId: item.ptE1AnswerId,
            ptE2Answer: item.ptE2Answer,
            ptE2AnswerId: item.ptE2AnswerId,
            ptE3Answer: item.ptE3Answer,
            ptE3AnswerId: item.ptE3AnswerId,
          }));

          const pteJobQuestions = res.data.jobQuestions?.map((item) => ({
            questionId: item.questionId,
            question: item.question,
            ptE1Answer: item.ptE1Answer,
            ptE1AnswerId: item.ptE1AnswerId,
            ptE2Answer: item.ptE2Answer,
            ptE2AnswerId: item.ptE2AnswerId,
            ptE3Answer: item.ptE3Answer,
            ptE3AnswerId: item.ptE3AnswerId,
          }));

          this.setState((prevState) => ({
            pendingApprovalsView: {
              ...prevState.pendingApprovalsView,
              trainingRequestId: res.data.trainingRequestId,
              courseCode: res.data.courseCode,
              courseTitle: res.data.courseTitle,
              statusId: res.data.statusId,
              status: res.data.status,
              // currentStatus: res.data.currentStatus,
              comments: res.data.comments,
              pteEvaluation: pteQuestions,
              pteJobEvaluation: pteJobQuestions,
            },
          }));
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  ShowPendingSubmissionById = (trainingRequestId, status1, status) => {
    const { pendingApprovalsList } = this.state;
    this.clearAllData();
    let apiUrl = `${API.GET_TRAINING_REQUEST_ID}?requestId=${trainingRequestId}`;
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });

    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
        if (res.status === 200) {
          this.state.pendingApprovalsView.trainingRequestId = res.data.id;
          this.setState(
            {
              pendingApprovalsView: {
                ...this.state.pendingApprovalsView,
                courseStartDate: res.data.courseStartDate,
                reviewerId: res.data.reviewerId ? res.data.reviewerId : 0,
                pendingStatus: status,
                trainingRequestId: res.data.id,
                trainingBond: {
                  fileId: res.data.trainingBond.fileId,
                  fileName: res.data.trainingBond.fileName,
                },
                certificate: {
                  fileId: res.data.certificate.fileId,
                  fileName: res.data.certificate.fileName,
                },
                ...res.data,
              },
              certificateExpiryDateApproval: res.data.certificateExpiryDate,
              isSubmissionLoader: false,
              isSubmissionFailed: false,
            },
            () => {
              console.log(this.state.pendingApprovalsView.courseStartDate);
            }
          );

          if (res.data.certificate.fileName && res.data.certificate.fileId) {
            this.setState({
              isPdf: true,
            });
          } else {
            this.setState({
              isPdf: false,
            });
          }
        }
        if (
          status1 === UserStatus.PENDING_FOR_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_ADMIN_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_GM_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_MANAGER_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_SUPERVISOR_APPROVAL
        ) {
          this.propertiesScreen();
          // this.GetHistoryLogList(trainingRequestId);
        } else if (status1 === UserStatus.PENDING_TRAIN_BOND) {
          this.propertiesScreen();
          // this.GetHistoryLogList(trainingRequestId);
        } else if (
          status1 === UserStatus.PENDING_FOR_CERT ||
          status1 === UserStatus.PENDING_FOR_COURSE_COMPLETION
        ) {
          this.propertiesScreen();
          // this.GetHistoryLogList(trainingRequestId);
        } else if (status1 === UserStatus.PENDING_CERT_UPLOAD) {
          this.CertificateScreen();
          // this.GetHistoryLogList(trainingRequestId);
        } else if (
          status1 === UserStatus.PENDING_FOR_LOU ||
          status1 === UserStatus.PENDING_FOR_COURSE_QUESTIONNAIRE ||
          status1 === UserStatus.PENDING_REVIEW_COURSE_QUESTIONNAIRE
        ) {
          this.pteScreen();
          // this.GetCourseQuestionaireDetails();
          // this.GetLouDetails();
          // this.SkillsData();
          // this.JobsData();
          // this.CourseQuestAnswers();
          // this.GetHistoryLogList(trainingRequestId);
        } else if (
          status1 === UserStatus.PENDING_FOR_PTE1_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_PTE2_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_PTE3_APPROVAL ||
          status1 === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE ||
          status1 === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE ||
          status1 === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE ||
          status1 === UserStatus.PTE1_UPDATE ||
          status1 === UserStatus.PTE2_UPDATE ||
          status1 === UserStatus.PTE3_UPDATE ||
          status1 === UserStatus.PTE1_REWORK ||
          status1 === UserStatus.PTE2_REWORK ||
          status1 === UserStatus.PTE3_REWORK
        ) {
          // this.SkillsData();
          // this.JobsData();
          // this.getPteQuestionDetails();
          this.pteScreen();
          // this.GetHistoryLogList(trainingRequestId);
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  //Evolution Answer Skill Data
  SkillsData = async () => {
    let apiurl = `${API.GET_EVAL_ANS}`;
    let res = await this.updateGetFunction(apiurl);
    if (res.status === 200) {
      const evaluationAns = res.data?.map((item) => ({
        id: item.id,
        name: item.name,
      }));

      this.state.pendingApprovalsView.evaluationAns = evaluationAns;
      // this.state.isSubmissionLoader = false;
      // this.state.isSubmissionFailed = false;
      this.setState({});
      // this.setState({ pendingApprovalsView: { evaluationAns: evaluationAns }, isSubmissionLoader: false, isSubmissionFailed: false });
    }
  };

  CourseQuestAnswers = async () => {
    let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    let res = await this.updateGetFunction(apiurl);
    if (res.status === 200) {
      const evaluationAns = res.data?.map((item) => ({
        id: item.id,
        name: item.name,
      }));

      this.state.pendingApprovalsView.CourseQuestAnswers = evaluationAns;
      // this.state.isSubmissionLoader = false;
      // this.state.isSubmissionFailed = false;
      this.setState({});
      // this.setState({ pendingApprovalsView: { evaluationAns: evaluationAns }, isSubmissionLoader: false, isSubmissionFailed: false });
    }
  };

  //Job Answer Skill Data
  JobsData = async () => {
    let apiurl = `${API.GET_SKILL_STATUS}`;
    let res = await this.updateGetFunction(apiurl);
    if (res.status === 200) {
      const skillStatus = res.data?.map((item) => ({
        id: item.id,
        name: item.name,
      }));
      // this.setState({ pendingApprovalsView: { skillStatus: skillStatus }, isSubmissionLoader: false, isSubmissionFailed: false });
      this.state.pendingApprovalsView.skillStatus = skillStatus;
      // this.state.isSubmissionLoader = false;
      // this.state.isSubmissionFailed = false;
      this.setState({});
    }
  };

  ///////////////////////////////////////End PTE Details///////////////////////////////////////////////////////

  // Toasts
  ApproveToast = (pendingStatus) => {
    $("#propertiesScreen").removeClass("show");
    $("#certificateUploadScreen").addClass("visible-hide");
    $("#certificateUploadScreen").removeClass("visible-show");
    $("#pteScreen").removeClass("show"); //

    $("body").removeClass("scrollhide");

    if (
      pendingStatus === UserStatus.PENDING_FOR_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_ADMIN_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_GM_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_MANAGER_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_SUPERVISOR_APPROVAL
    ) {
      toast.success("Request approved successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_LOU) {
      toast.success("LOU submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_TRAIN_BOND_UPLOAD) {
      toast.success("Training Bond submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_CERT_UPLOAD) {
      toast.success("Certificate submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_COURSE_QUESTIONNAIRE) {
      toast.success("Course questionnaire submitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (
      pendingStatus === UserStatus.PENDING_REVIEW_COURSE_QUESTIONNAIRE
    ) {
      toast.success("Course questionnaire reviewed successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_COURSE_COMPLETION) {
      toast.success("Course completion updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_CERT) {
      toast.success("Certificate approved successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.TRAINING_COMPLETED) {
      toast.success("Training completed successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PTE1_UPDATE) {
      toast.success("PTE1 updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PTE2_UPDATE) {
      toast.success("PTE2 updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PTE3_UPDATE) {
      toast.success("PTE3 updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PTE1_REWORK) {
      toast.success("PTE1 resubmitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PTE2_REWORK) {
      toast.success("PTE2 resubmitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PTE3_REWORK) {
      toast.success("PTE3 resubmitted successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE) {
      toast.success("PTE1 acknowledged successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE) {
      toast.success("PTE2 acknowledged successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE) {
      toast.success("PTE3 acknowledged successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE1_APPROVAL) {
      toast.success("PTE1 approved successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE2_APPROVAL) {
      toast.success("PTE2 approved successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE3_APPROVAL) {
      toast.success("PTE3 approved successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    // toast.success("Request approved successfully", {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
  };

  ErrorToast = (pendingStatus) => {
    // $("#propertiesScreen").removeClass("show");
    // $("#certificateUploadScreen").addClass("visible-hide");
    // $("#certificateUploadScreen").removeClass("visible-show");
    // $("#pteScreen").removeClass("show"); //

    // $("body").removeClass("scrollhide");

    if (
      pendingStatus === UserStatus.PENDING_FOR_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_ADMIN_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_GM_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_MANAGER_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_SUPERVISOR_APPROVAL
    ) {
      swal("Error when approving the request.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PENDING_FOR_LOU) {
      swal("Error when submitting the Lou.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PENDING_TRAIN_BOND_UPLOAD) {
      swal(
        "Error when submitting the training bond.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_CERT_UPLOAD) {
      swal(
        "Error when submitting the certificate.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_FOR_COURSE_QUESTIONNAIRE) {
      swal(
        "Error when submitting the course questionnaire.",
        "Please try again.",
        "warning"
      );
    } else if (
      pendingStatus === UserStatus.PENDING_REVIEW_COURSE_QUESTIONNAIRE
    ) {
      swal(
        "Error when reviewing the course questionnaire.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_FOR_COURSE_COMPLETION) {
      swal(
        "Error when submitting the course completion.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_FOR_CERT) {
      swal(
        "Error when approving the certificate.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.TRAINING_COMPLETED) {
      swal(
        "Error when training is completing.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PTE1_UPDATE) {
      swal("Error when updating the PTE1.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PTE2_UPDATE) {
      swal("Error when updating the PTE2.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PTE3_UPDATE) {
      swal("Error when updating the PTE3.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PTE1_REWORK) {
      swal("Error when resubmitting the PTE1.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PTE2_REWORK) {
      swal("Error when resubmitting the PTE2.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PTE3_REWORK) {
      swal("Error when resubmitting the PTE3.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE) {
      swal(
        "Error when acknowledging the PTE1.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE) {
      swal(
        "Error when acknowledging the PTE2.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE) {
      swal(
        "Error when acknowledging the PTE3.",
        "Please try again.",
        "warning"
      );
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE1_APPROVAL) {
      swal("Error when approving the PTE1.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE2_APPROVAL) {
      swal("Error when approving the PTE2.", "Please try again.", "warning");
    } else if (pendingStatus === UserStatus.PENDING_FOR_PTE3_APPROVAL) {
      swal("Error when approving the PTE3.", "Please try again.", "warning");
    }
  };

  handleRejectPopup = () => {
    const { pendingStatus } = this.state;
    $("#propertiesScreen").removeClass("show");
    $("#pteScreen").removeClass("show"); //
    $("#certificateUploadScreen").addClass("visible-hide");
    $("#certificateUploadScreen").removeClass("visible-show");

    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");

    if (
      pendingStatus === UserStatus.PENDING_FOR_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_ADMIN_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_GM_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_MANAGER_APPROVAL ||
      pendingStatus === UserStatus.PENDING_FOR_SUPERVISOR_APPROVAL
    ) {
      this.handleReject();
    } else if (pendingStatus?.includes("pte")) {
      this.handlePteReject();
    }
    // else if (pendingStatus === UserStatus.PENDING_FOR_COURSE_COMPLETION) {
    //   this.handleCertReject();
    // }
    else if (
      pendingStatus === UserStatus.PENDING_REVIEW_COURSE_QUESTIONNAIRE ||
      pendingStatus === UserStatus.PENDING_TRAIN_BOND
    ) {
      this.handleCancel();
    } else if (pendingStatus === UserStatus.PENDING_FOR_CERT) {
      this.handleCertReject();
    }

    // toast.success("Request rejected successfully", {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
  };
  closeReject = () => {
    $("body").removeClass("scrollhide");
  };
  // End Toasts

  //Handling Radio

  handlePteRadio = (e, questionId, radioAns, answerId, question) => {
    const { pteRadioAns, pendingApprovalsView } = this.state;

    if (this.state.pendingStatus?.includes("rework")) {
      pendingApprovalsView.pteEvaluation?.map(
        (questionValue) =>
          (this.state.pendingStatus?.includes("1") &&
            (questionId === questionValue.questionId
              ? ((questionValue.ptE1AnswerId = parseInt(e.target.id)),
                (questionValue.ptE1Answer = e.target.value))
              : "")) ||
          (this.state.pendingStatus?.includes("2") &&
            (questionId === questionValue.questionId
              ? ((questionValue.ptE2AnswerId = parseInt(e.target.id)),
                (questionValue.ptE2Answer = e.target.value))
              : "")) ||
          (this.state.pendingStatus?.includes("3") &&
            (questionId === questionValue.questionId
              ? ((questionValue.ptE3AnswerId = parseInt(e.target.id)),
                (questionValue.ptE3Answer = e.target.value))
              : ""))
      );

      pendingApprovalsView.pteJobEvaluation?.map(
        (skillsValue) =>
          (this.state.pendingStatus?.includes("1") &&
            (questionId === skillsValue.questionId
              ? ((skillsValue.ptE1AnswerId = parseInt(e.target.id)),
                (skillsValue.ptE1Answer = e.target.value))
              : "")) ||
          (this.state.pendingStatus?.includes("2") &&
            (questionId === skillsValue.questionId
              ? ((skillsValue.ptE2AnswerId = parseInt(e.target.id)),
                (skillsValue.ptE2Answer = e.target.value))
              : "")) ||
          (this.state.pendingStatus?.includes("3") &&
            (questionId === skillsValue.questionId
              ? ((skillsValue.ptE3AnswerId = parseInt(e.target.id)),
                (skillsValue.ptE3Answer = e.target.value))
              : ""))
      );
      this.setState({});
    } else {
      if (pteRadioAns?.length === 0) {
        pteRadioAns.push({
          questionId: questionId,
          radioAns: radioAns,
          question: question,
          answerId: answerId,
        });
        this.setState({
          pteRadioAns: pteRadioAns,
        });
      } else {
        let existingItem = pteRadioAns.findIndex(
          (item) => item.questionId === questionId
        );
        if (existingItem === -1) {
          pteRadioAns.push({
            questionId: questionId,
            radioAns: radioAns,
            question: question,
            answerId: answerId,
          });
          this.setState({
            pteRadioAns: pteRadioAns,
          });
        } else {
          pteRadioAns[existingItem].radioAns = e.target.value;
          pteRadioAns[existingItem].answerId = answerId;
          this.setState({
            pteRadioAns: pteRadioAns,
          });
        }
      }
    }
  };

  //Handling Uploading attachments......

  fileNameAttachments = (e) => {
    if (e?.target?.files?.length > 0) {
      this.state.uploadedFileName = e?.target?.files[0]?.name;
      const fileType = this.state.uploadedFileName
        ?.split(".")
        .pop()
        .toLowerCase();
      //const fileType = fileName?.split(".").pop().toLowerCase();
      const supportedFormats = Object.values(certificateUploadFormats).flat();
      if (supportedFormats.includes(fileType) || fileType === "heic") {
        this.state.trainingBondFormData = e.target?.files[0];
        this.setState({
          isPdf: true,
        });
      } else {
        this.setState({
          isPdf: false,
          uploadedFileName: "",
        });
        toast.error(
          //"The selected file format is not applicable. Please select PDF file format",
          "The selected file format is not applicable.",
          {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          }
        );
      }
    }
  };
  handleFileClose = () => {
    $("#inputGroupFile1").val("");
    this.setState({
      uploadedFileName: "",
      isPdf: false,
      pendingApprovalsView: {
        ...this.state.pendingApprovalsView,
        certificate: {
          fileId: 0,
          fileName: "",
        },
      },
    });
  };

  handleFilesOpen = async () => {
    let certApi = `${API.GET_FILES_URL}?fileId=${this.state.pendingApprovalsView.certificate.fileId}`;
    let trainApi = `${API.GET_FILES_URL}?fileId=${this.state.pendingApprovalsView.trainingBond.fileId}`;
    let res = await this.updateGetFunction(
      this.state.pendingStatus === UserStatus.PENDING_FOR_COURSE_COMPLETION
        ? trainApi
        : certApi
    );
    if (res.status === 200) {
      this.setState({
        pendingApprovalsView: {
          ...this.state.pendingApprovalsView,
          fileUrl: res.data,
        },
        isSubmissionLoader: false,
        isSubmissionFailed: false,
      });
      // window.open(res.data)
      res.data && window.open(res.data);
    }
  };

  //End Handling Uploading attachments......

  //////////////////////////////////////////Pending for Training Bond && Certificate Upload/////////////////////////////////

  uploadFiles = () => {
    if (this.state.trainingBondFormData) {
      let uploadformData = new FormData();
      this.state.pendingStatus === UserStatus.PENDING_TRAIN_BOND
        ? uploadformData?.append("files", this.state.trainingBondFormData)
        : uploadformData?.append("files", this.state.trainingBondFormData);
      uploadformData?.append(
        "dataitem",
        JSON.stringify({
          Id: parseInt(this.state.trainingRequestId),
          Comments: this.state.TrainingBondComments,
          ExpiryDate: this.state.certificateEndDate,
        })
      );
      let apiUrl =
        this.state.pendingStatus === UserStatus.PENDING_TRAIN_BOND
          ? `${API.GET_UPLOAD_TRAINING_BOND}?userId=${this.state.UserId}`
          : `${API.POST_CERTIFICATE_UPLOAD}?userId=${this.state.UserId}`;
      this.setState({
        isSubmissionLoader: true,
        isSubmissionFailed: false,
      });
      axios({
        method: "POST",
        url: apiUrl,
        data: uploadformData,
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then((res) => {
          this.setState({
            isSubmissionLoader: true,
            isSubmissionFailed: false,
          });
          if (res.status === 200) {
            $("#inputGroupFile1").val("");
            this.setState({
              isSubmissionLoader: false,
              isSubmissionFailed: false,
              isFileEmpty: false,
            });
            this.GetMyPendingApprovalsList(
              this.state.currentPage,
              this.state.perPage
            );
            toast.success(
              this.state.pendingStatus === UserStatus.PENDING_CERT_UPLOAD
                ? "Certificate uploaded successfully"
                : "Submitted successfully",
              {
                position: toast.POSITION.TOP_RIGHT,
                color: "#fff",
              }
            );
            $("#propertiesScreen").removeClass("show");
            $("#pteScreen").removeClass("show");
            $("#certificateUploadScreen").addClass("visible-hide");
            $("#certificateUploadScreen").removeClass("visible-show");
            $("body").removeClass("scrollhide");
            this.setState({});
          }
        })
        .catch((error) => {
          logoutFunction(error?.response?.status);
          console.log(error);
          this.setState({ isSubmissionLoader: false });
          swal(
            this.state.pendingStatus === UserStatus.PENDING_CERT_UPLOAD
              ? "Error when uploading the certificate."
              : "Error when uploading the training bond",
            "Please try again.",
            "warning"
          );
        });
    } else {
      this.state.isFileEmpty = true;
      this.state.pendingStatus === UserStatus.PENDING_TRAIN_BOND
        ? this.trainingBondRef.current.focus()
        : this.certificateRef.current.focus();
    }
  };

  //////////////////////////////////////////End Pending for Training Bond & Certificate Upload/////////////////////////////////

  ////////////////////////////////Pending for Certificate Approval & Reject///////////////////////////////////////

  handleCertApprove = async () => {
    const {
      UserId,
      pendingApprovalsView,
      TrainingBondComments,
      pendingStatus,
    } = this.state;
    this.updateExpiryDate();
    let apiUrl = `${API.POST_CERT_APPROVE}?userId=${UserId}`;
    let postData = {
      trainingRequestId: this.state.trainingRequestId,
      comments: TrainingBondComments,
    };
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    let res = await this.updatePostFunction(apiUrl, postData);
    if (res.status === 200) {
      this.ApproveToast(pendingStatus);
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );

      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      this.ErrorToast(pendingStatus);
    }
  };

  updateExpiryDate = () => {
    let dataObj = {
      Id: this.state.pendingApprovalsView?.id,
      ExpiryDate: this.state.certificateExpiryDateApproval
        ? moment(this.state.certificateExpiryDateApproval).toISOString()
        : null,
      IsUpdateExpiryDate: true,
    };
    let uploadformData = new FormData();
    uploadformData?.append("dataitem", JSON.stringify(dataObj));
    let apiUrl = API.POSTPUT_MANUAL_TRAININGS + "?userId=" + this.state.UserId;
    axios({
      method: "PUT",
      url: apiUrl,
      data: uploadformData,
    })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
        } else {
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  handleCertReject = async () => {
    const { UserId, pendingApprovalsView, TrainingBondComments } = this.state;
    let apiUrl = `${API.POST_CERT_REJECT}?userId=${UserId}`;
    let postData = {
      trainingRequestId: this.state.trainingRequestId,
      comments: TrainingBondComments,
    };
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    let res = await this.updatePostFunction(apiUrl, postData);
    if (res.status === 200) {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );

      // this.RejectToast();
      toast.success("Certificate rejected successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      swal(
        "Error when rejecting the certificate",
        "Please try again.",
        "warning"
      );
    }
  };

  ////////////////////////////////End Pending for Certificate Approval///////////////////////////////////////

  ////////////////////////////////Pending for Update Course Completion///////////////////////////////////////

  handleCourseCompleted = async () => {
    const {
      UserId,
      pendingApprovalsView,
      TrainingBondComments,
      pendingStatus,
    } = this.state;
    let apiUrl = `${API.POST_COURSE_COMPLETION}?userId=${UserId}`;
    let postData = {
      trainingRequestId: this.state.trainingRequestId,
      comments: TrainingBondComments,
      courseCompleted: true,
    };
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    let res = await this.updatePostFunction(apiUrl, postData);
    if (res.status === 200) {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );

      this.ApproveToast(pendingStatus);
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      this.ErrorToast(pendingStatus);
    }
  };

  handleCourseNotCompleted = async () => {
    const {
      UserId,
      pendingApprovalsView,
      TrainingBondComments,
      pendingStatus,
    } = this.state;
    let apiUrl = `${API.POST_COURSE_COMPLETION}?userId=${UserId}`;
    let postData = {
      trainingRequestId: this.state.trainingRequestId,
      comments: TrainingBondComments,
      courseCompleted: false,
    };
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    let res = await this.updatePostFunction(apiUrl, postData);
    if (res.status === 200) {
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );

      this.ApproveToast(pendingStatus);
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      this.ErrorToast(pendingStatus);
    }
  };

  ////////////////////////////////End Pending for Update Course Completion///////////////////////////////////////

  // onChange function for Comments

  handleTBondComments = (e) => {
    this.setState({
      TrainingBondComments: e.target.value,
    });
  };

  //onChange Function for EndDate
  getEndDate = (e) => {
    const inputDate = e;
    this.state.certificateEndDate = inputDate ? inputDate : "";
    // this.state.certificateEndDate = e.target.value;
    this.setState({});
  };

  //Getting Course Questionaire Details
  GetCourseQuestionaireDetails = (status) => {
    let apiUrl = `${API.GET_COURSE_QUESTIONAIRE}?trainingRequestId=${this.state.trainingRequestId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.questions == null) {
            if (
              status === UserStatus.PENDING_FOR_COURSE_QUESTIONNAIRE ||
              status === UserStatus.PENDING_FOR_LOU
            ) {
              swal(
                "Warning!",
                "Course questionnaire has been disabled for this course.\nPlease contact Manager/Supervisor.",
                "warning"
              );
            }
          }
          this.state.courseQuestionaire = res.data;
          this.setState({});
          this.state.courseQuestionaire.questions?.map((item, index) => {
            this.state.postCourseAnswers = [
              ...this.state.postCourseAnswers,
              {
                coureseQuestionsId: item.questionId,
                questions: item.question,
                coureseAnswerId: 0,
                coureseAnswer: "",
                answerValue: 0,
              },
            ];
            this.setState({});
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  //Getting LOU Details

  GetLouDetails = () => {
    let apiUrl = `${API.GET_PENDING_LOU}?trainingRequestId=${this.state.trainingRequestId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.LouDetails = res.data;

          // this.state.isSubmissionLoader = false;
          this.setState({});
          this.state.louQuestions?.questions?.map((item, index) => {
            this.state.postLOUAnswers = [
              ...this.state.postLOUAnswers,
              {
                questionId: item.questionId,
                answerValue: "",
                question: item.question,
                answer: "",
              },
            ];
            this.setState({});
          });
        }
      })
      .catch((err) => {
        logoutFunction(err?.response?.status);
        console.log(err);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  // Handle Lou Screens Inputs
  // handleLouInputchange = (e, questionId, index, question) => {
  //   const {inputValues} = this.state;
  //   var GetLOUQuestionaire = this.state.postLOUAnswers;
  //   const inputValue = e.target.value;
  //   const regex = /textbox/g;
  //   const matches = question?.match(regex);
  //   const numberOfInputs = matches ? matches?.length : 0;
  //   // const inputValues = [];
  //   for (let i = 0; i < numberOfInputs; i++) {
  //     if(i == index){
  //       inputValues?.splice(index,1,inputValue);
  //     }
  //     // inputValues?.push(inputValue)
  //   }
  //   var Result = {
  //     questionId: questionId,
  //     answerId: 0,
  //     question: question,
  //     answer: e.target.value,
  //   };
  //   GetLOUQuestionaire[index] = Result;
  // };

  // handleLouInputchange = (e, questionId, index, question) => {

  //   const inputValue = e.target.value;

  //   // const newInputValues = [...inputValues];
  //   const newInputValues = this.state.inputValues;

  //   newInputValues[questionId] = newInputValues[questionId] || [];
  //   newInputValues[questionId][index] = inputValue;

  //   this.setState({ inputValues: newInputValues },() => {console.log("After setting Input Values",this.state.inputValues)});
  //   const answer = newInputValues[questionId].filter(val => val !== undefined).join(', ');

  //   const result = {
  //     questionId: questionId,
  //     answerId: 0,
  //     question: question,
  //     answer: answer,
  //   };

  //   // const newGetLOUQuestionaire = [...this.state.postLOUAnswers];
  //   const newGetLOUQuestionaire = this.state.postLOUAnswers;
  //   newGetLOUQuestionaire[questionId] = result;
  //   console.log("Onchange LOUAnswers",this.state.postLOUAnswers);
  //   console.log(newGetLOUQuestionaire);
  //   this.setState({ postLOUAnswers: newGetLOUQuestionaire });
  // };

  handleLouInputchange = (e, questionId, index, question, louDetails) => {
    const inputValue = e.target.value;
    if (
      this.state.inputValues?.length > 0 ||
      this.state.inputValues !== undefined ||
      this.state.inputValues !== null
    ) {
      const newInputValues = [...this.state.inputValues];
      louDetails?.questions?.map((item, ind) => {
        newInputValues[ind] = newInputValues[ind] || [];
        if (item.questionId == questionId) {
          newInputValues[ind][index] = inputValue;
          this.setState({ inputValues: newInputValues });
          const answer = newInputValues[ind].join("&*&");
          const result = {
            questionId: questionId,
            answerId: 0,
            question: question,
            answer: answer,
          };
          const newGetLOUQuestionaire = [...this.state.postLOUAnswers];
          newGetLOUQuestionaire[ind] = result;
          this.setState({ postLOUAnswers: newGetLOUQuestionaire });
        }
      });
      // newInputValues[index] = newInputValues[index] || [];
      // newInputValues[index] = inputValue;
    } else {
      this.state.inputValues = [];
    }
  };

  //   handleLouInputchange = (e, questionId, index, question , loudetails) => {

  //     console.log(e.target.value, questionId, this.state.postLOUAnswers, this.state.LouDetails)
  //     const inputValue = e.target.value;
  //     const updatedPostLOUAnswers = this.state.postLOUAnswers;

  //     // this.setState({
  //     //  updatedPostLOUAnswers[questionId] :
  //     // })

  //    const regex = /textbox/g;
  //     const matches = question?.match(regex);
  //     const numberOfInputs = matches ? matches?.length : 0;
  //     const inputValues = [];
  //     for (let i = 0; i < numberOfInputs; i++) {
  //       inputValues?.push(inputValue);
  //     }

  //        var Result = {
  //       questionId: questionId,
  //       answerId: 0,
  //       question: question,
  //       answer: e.target.value,
  //     };

  //     // this.setState(prevState => {
  //     //     const updatedPostLOUAnswers = [...prevState.postLOUAnswers];
  //     //     updatedPostLOUAnswers[questionId] = {
  //     //         questionId: questionId,
  //     //         answerId: prevState.postLOUAnswers[index]?.answerId || 0,
  //     //         question: question,
  //     //         answer: inputValue,
  //     //     };

  //     //     return {
  //     //         postLOUAnswers: updatedPostLOUAnswers,
  //     //     };
  //     // });
  // };

  //   handleLouInputchange = (e, questionId, index, question) => {
  //     const inputValue = e.target.value;

  //     this.setState(prevState => {
  //         const updatedPostLOUAnswers = prevState.postLOUAnswers.map((answer, i) => {
  //             if (i === index) {
  //                 return {
  //                     questionId: questionId,
  //                     answerId: answer.answerId,
  //                     question: question,
  //                     answer: inputValue,
  //                 };
  //             } else {
  //                 return answer;
  //             }
  //         });

  //         return {
  //             postLOUAnswers: updatedPostLOUAnswers,
  //         };
  //     });
  // };

  //Handling Agree for props.
  updateAgreeState = (isAgree, isDontAgree) => {
    this.setState({
      isAgree: isAgree,
      isDontAgree: isDontAgree,
    });
  };
  handleAgree = () => {
    this.setState({
      isAgree: true,
      isDontAgree: false,
    });
  };

  handleDontAgree = () => {
    this.setState({
      isAgree: false,
      isDontAgree: true,
    });
  };

  //Lou Evaluation
  postLOUEvaluation = async () => {
    const { pendingStatus } = this.state;
    let postInputs = this.state.postLOUAnswers;
    let NumberOfTextBox = 0;

    //Calculating Number of textbox
    this.state.LouDetails?.questions?.map((item) => {
      const textBoxRegex = /\btextbox\b/gi;
      NumberOfTextBox +=
        parseInt(item.question.match(textBoxRegex)?.length) || 0;
    });

    if (
      NumberOfTextBox == NaN ||
      NumberOfTextBox == undefined ||
      NumberOfTextBox == null
    ) {
      NumberOfTextBox = 0;
    }
    const inputs = postInputs?.filter(
      (item) => item !== undefined && item.length !== 0
    ); //For filtering undefined values

    let isValid = false;
    let ansCount = 0;
    //Calculating Number of Answer Values
    inputs?.map((item) => {
      const textBoxRegex = /\btextbox\b/gi;
      if (item.answer !== "") {
        if (item.question?.match(textBoxRegex)?.length > 1) {
          item.answer?.split("&*&").map((items) => {
            items?.trim().length > 0 && ansCount++;
          });
        } else {
          ansCount++;
        }
      }
      // else{
      //   ansCount = 0;
      // }
    });

    //Checking is Valid or Not ?
    if (ansCount === NumberOfTextBox) {
      isValid = true;
    }

    const result = inputs?.filter((item) => item.question?.includes("textbox"));

    if (isValid) {
      if (this.state.isAgree === true || this.state.isDontAgree === true) {
        this.setState({ isSubmissionLoader: true });
        let apiUrl = `${API.POST_PENDING_LOU}?userId=${this.state.UserId}`;
        let louEvaluation = {
          trainingRequestId: this.state.trainingRequestId,
          isLouAgree: this.state.isAgree,
          lou: inputs,
          comments: this.state.TrainingBondComments,
        };
        let res = await this.updatePostFunction(apiUrl, louEvaluation);
        if (res.status === 200) {
          this.GetMyPendingApprovalsList(
            this.state.currentPage,
            this.state.perPage
          );
          this.ApproveToast(pendingStatus);
          this.setState({
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        } else {
          this.ErrorToast(pendingStatus);
        }
      } else {
        toast.error("Please select any one checkbox", {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        });
      }
    } else {
      toast.error(
        "Please fill all the fields, If it is not applicable fill it as NA",
        {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        }
      );
    }
  };

  //Handling Radio Inputs
  onChangeRadioValue = (e, questionId, question, answerId, answer, index) => {
    var GetCourseQuestionaire = this.state.postCourseAnswers;
    var Result = {
      coureseQuestionsId: questionId,
      questions: question,
      coureseAnswerId: answerId,
      coureseAnswer: answer,
      answerValue: 0,
    };
    GetCourseQuestionaire[index] = Result;
  };

  //Course Questionairee Evaluation
  postCourseEvaluation = async () => {
    const { pendingStatus } = this.state;
    const inputs = this.state.postCourseAnswers;
    const isValid = inputs.every((input) => input.coureseAnswerId !== 0);
    if (isValid) {
      this.setState({ isSubmissionLoader: true });
      let courseEvaluation = {
        trainingRequestId: this.state.trainingRequestId,
        courseQuestionaireEvaluations: [...this.state.postCourseAnswers],
        comments: this.state.courseRemarks,
      };
      let apiUrl = `${API.POST_COURSE_QUESTIONAIRE}?userId=${this.state.UserId}`;
      let res = await this.updatePostFunction(apiUrl, courseEvaluation);
      if (res.status === 200) {
        this.ApproveToast(pendingStatus);
        this.GetMyPendingApprovalsList(
          this.state.currentPage,
          this.state.perPage
        );

        this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
      } else {
        this.ErrorToast(pendingStatus);
      }
    } else {
      toast.error("Please select all the questions", {
        position: toast.POSITION.TOP_RIGHT,
        color: "#fff",
      });
    }
  };
  courseQuestApproval = async () => {
    const { UserId, TrainingBondComments, trainingRequestId, pendingStatus } =
      this.state;
    let apiUrl = `${API.POST_CQ_APPROVAL}?userId=${UserId}`;
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    let CourseData = {
      trainingRequestId: trainingRequestId,
      approveToPte1: true,
      comments: TrainingBondComments,
    };
    let res = await this.updatePostFunction(apiUrl, CourseData);
    if (res.status === 200) {
      this.ApproveToast(pendingStatus);
      this.GetMyPendingApprovalsList(
        this.state.currentPage,
        this.state.perPage
      );
      this.setState({ isSubmissionLoader: false, isSubmissionFailed: false });
    } else {
      this.ErrorToast(pendingStatus);
    }
  };

  HandleFileOpen = (id) => {
    const fileInput = document.getElementById(id);
    fileInput.click();
  };

  render() {
    if (this.state.navigate) {
      return <Navigate to="/home" replace={true} />;
    }
    const {
      isMobile,
      isSMobile,
      TrainingBondComments,
      validateComments,
      isPdf,
      uploadedFileName,
      smallfocusRef,
      isFileEmpty,
      isSmallMobile,
      historyLogList,
      LouDetails,
      courseQuestionaire,
      pendingApprovalsList,
      pendingStatus,
      currentUser,
      pendingApprovalsView,
      certificateEndDate,
      isRadioMobile,
      isSubmissionLoader,
      sortBy,
      order,
      isNext,
      perPage,
      inputValues,
    } = this.state;
    let { menuToggle } = this.props;
    return (
      <>
        {$("#propertiesScreen").hasClass("show") ||
        $("#pteScreen").hasClass("show") ||
        $("#searchScreen").hasClass("visible-show") ||
        $("certificateUploadScreen").hasClass("visible-show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div
          className={`${
            isMobile
              ? "main-body-mobile"
              : menuToggle
              ? "menu-main-body"
              : "main-body"
          } `}
        >
          <Loader isLoader={isSubmissionLoader} />
          {/* {isMobile == true ? (
            <div className="mobile-head border-bottom w-100">
              <div className="col-12 mobile-title">
                My pending tasks
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title ">

                <>
                  <CommonIcon fileName="PendingApprovalIcon" />
                  <span className="pl-10 head-span">
                    My pending tasks
                  </span>
                </>

                <CommonIcon fileName="searchIcon" />

              </div>
            </div>
          )} */}

          {/* {isMobile == true ? (
              // <div className="">
              <>
                <span className="mobile-head border-bottom w-100">
                  My pending tasks
                </span>
                <CommonIcon fileName="searchIcon" />
                <button className={`displaybutton text-end  ${isRadioMobile ? "pr-0" : ""} ${isSmallMobile ? "pl-0" : ""}`} id="displaybuttoncolor" onClick={() => this.openSearch()}>

                </button>
              </>
              // </div>
            ) : (
              <div className="title buttonFullWidth pr-0 align-items-center">
                <div className={`p-0 mr-0 ${menuToggle ? 'w-95' : 'w-80'}`}>
                  <span className=""><CommonIcon fileName="PendingApprovalIcon" /></span>
                  <span className="pl-10 head-span">
                    My pending tasks
                  </span>
                </div>
                <div className="text-end">
                  <button className={`displaybutton ${isRadioMobile ? "pr-0" : ""} ${isSmallMobile ? "pl-0" : ""}`} id="displaybuttoncolor" onClick={() => this.openSearch()}>
                    <CommonIcon fileName="searchIcon" />
                  </button>
                </div>
              </div>

            )} */}
          <div className="pendingTask-head-fixed">
            {isMobile == true ? (
              <>
                <div className={`p-0 mr-0 w-80 `}>
                  <span
                    className={`mobile-head border-bottom w-100 d-flex justify-content-between`}
                  >
                    <span className="mobile-title"> My pending tasks</span>
                    <span className="d-flex gap-3">
                      <span onClick={() => this.openSearch()}>
                        <CommonIcon fileName="searchIcon1" />
                      </span>
                      <span onClick={() => this.setState({ navigate: true })}>
                        <CommonIcon fileName="prevBackIcon" />
                      </span>
                    </span>
                  </span>
                </div>
                {/* <div className={`text-end "w-20 ${isSMobile ? "w-20" : "w-24"}`}>
                  <button className={`displaybutton ${isRadioMobile ? "pr-0" : ""} ${isSmallMobile ? "pl-0" : ""}`} id="displaybuttoncolor" onClick={() => this.openSearch()}>
                    <CommonIcon fileName="searchIcon" />
                  </button>
                </div> */}
              </>
            ) : (
              // <div className="title buttonFullWidth row pr-0 align-items-center">
              //   <div
              //     className={`col-10 p-0 mr-0  ${menuToggle ? "w-80" : "w-60"}`}
              //   >
              //     <span>
              //       <CommonIcon fileName="Pendingheading" />
              //     </span>
              //     <span className="pl-10 head-span ">My pending tasks</span>
              //   </div>
              //   <div
              //     className={`col-2 text-end  ${menuToggle ? "w-20" : "w-24"}`}
              //   >
              //     <button
              //       className={`displaybutton ${isRadioMobile ? "pr-0" : ""} ${isSmallMobile ? "pl-0" : ""
              //         }`}
              //       id="displaybuttoncolor"
              //       onClick={() => this.openSearch()}
              //     >
              //       <CommonIcon fileName="searchIcon1" />
              //     </button>
              //     <button
              //       className={`displaybutton ${isRadioMobile ? "pr-0" : ""} ${isSmallMobile ? "pl-0" : ""
              //         }`}
              //       id="displaybuttoncolor"
              //       onClick={() => this.setState({ navigate: true })}
              //     >
              //       <CommonIcon fileName="prevBackIcon" />
              //     </button>
              //   </div>
              // </div>
              <div
                className={` ${
                  menuToggle ? "width-100" : "width-filter"
                } px-4 position-relative border-bottom row `}
              >
                <div className="col-6 border-none title">
                  <CommonIcon fileName="Pendingheading" />
                  <span className="pl-10 head-span">My pending tasks</span>
                </div>
                <div className="text-align-end  title border-none display text-16-red mt-3px col-6">
                  <span
                    className="text-20-bold pr-10 cursor-pointer"
                    onClick={() => this.openSearch()}
                  >
                    <CommonIcon fileName="filterIcon" />
                  </span>
                  <span
                    className="text-20-bold pr-30 cursor-pointer"
                    onClick={() => this.setState({ navigate: true })}
                  >
                    <CommonIcon fileName="prevBackIcon" />
                  </span>
                </div>
              </div>
            )}
          </div>
          <Toaster />
          <div
            className={`${
              isMobile ? "common-mobiletable-style" : "common-task-style"
            }`}
          >
            <div
              id="pendingTask"
              className="table-responsive common-table-bottom"
            >
              <div
                className={`table-fixed-header ${
                  isMobile
                    ? "table-scroll-xy-mobile top-105px"
                    : menuToggle
                    ? "table-scroll-xy-menutoggle top-115px"
                    : "table-scroll-xy top-115px"
                } table-list-view-bottom`}
              >
                <table className="table fileListTable2 table-borderless table-hover">
                  <thead>
                    <tr>
                      <td></td>
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("trainingRequestId")}
                      >
                        <span> Request ID </span>
                        {sortBy === "trainingRequestId" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("employeeCode")}
                      >
                        <span> Employee code </span>
                        {sortBy === "employeeCode" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("employeeName")}
                      >
                        <span> Employee name</span>
                        {sortBy === "employeeName" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("courseCode")}
                      >
                        <span> Course code</span>
                        {sortBy === "courseCode" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("courseTitle")}
                      >
                        <span> Course title</span>
                        {sortBy === "courseTitle" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                      {/* <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("requestedBy")}
                    >
                      <span> Requested for</span>
                      {sortBy === "requestedBy" && (
                        <CommonIcon
                          fileName={order === "asc" ? "downArrow" : "upArrow"}
                        />
                      )}
                    </td> */}
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("currentStatus")}
                      >
                        <span>Current status</span>
                        {sortBy === "currentStatus" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("requestedDate")}
                      >
                        <span> Requested date </span>
                        {sortBy === "requestedDate" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingApprovalsList?.length !== 0 ? (
                      pendingApprovalsList?.map((item, index) => (
                        <tr
                          id={"active" + item.id}
                          key={index}
                          className="requestRadioSelect"
                        >
                          <td></td>
                          <td
                            onClick={() =>
                              this.MyPendingSubmission(
                                item.id,
                                item.currentStatus
                                  ?.toLowerCase()
                                  ?.replace(/\s+/g, ""),
                                item.currentStatus
                              )
                            }
                          >
                            <span>
                              <a className="properties-view cursor-pointer">
                                {item.trainingRequestId}
                              </a>
                            </span>
                            {/* <span><a className="properties-view cursor-pointer">{item.requestorId}</a></span> */}
                          </td>
                          <td>
                            <span>{item.employeeCode} </span>
                          </td>
                          <td>
                            <span>{item.employeeName} </span>
                          </td>
                          <td>
                            <span>{item.courseCode} </span>
                          </td>
                          <td>
                            <span>{item.courseTitle} </span>
                          </td>
                          {/* <td>
                          <span>{item.requestedBy}</span>
                        </td> */}
                          <td>
                            <span>{item.currentStatus}</span>
                          </td>
                          <td>
                            <span>
                              {/* {item.requestedDate
                              ? moment(item.requestedDate).format(
                                  "DD-MMM-YYYY HH:MM A"
                                )
                              : ""} */}
                              {item.requestedDate
                                ? moment(
                                    new Date(Date.parse(item.requestedDate))
                                  ).format("DD-MMM-YYYY h:mm A")
                                : ""}
                            </span>
                          </td>
                          {/* <td></td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={12} className="table-nodata text-center">
                          {"No record found"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
          ></div>
        </div>
        {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

        {/* Screens for training bond && Approval && Certificate Approval && Update Course Completion*/}
        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="propertiesScreen"
        >
          <SmallCanvas
            pendingApprovalsView={pendingApprovalsView}
            isFileEmpty={isFileEmpty}
            validateComments={validateComments}
            isMobile={isMobile}
            currentUser={currentUser}
            pendingStatus={pendingStatus}
            isSmallMobile={isSmallMobile}
            isSMobile={isSMobile}
            isRadioMobile={isRadioMobile}
            isAgree={this.state.isAgree}
            isDontAgree={this.state.isDontAgree}
            uploadedFileName={this.state.uploadedFileName}
            isPdf={this.state.isPdf}
            certificateEndDate={this.state.certificateEndDate}
            TrainingBondComments={this.state.TrainingBondComments}
            historyLogList={historyLogList}
            closeProperties={this.closeProperties}
            handleFilesOpen={this.handleFilesOpen}
            handleFileClose={this.handleFileClose}
            fileNameAttachments={(e) => this.fileNameAttachments(e)}
            getEndDate={(e) => this.getEndDate(e)}
            handleTBondComments={(e) => this.handleTBondComments(e)}
            handleApprove={this.handleApprove}
            handleReject={this.handleReject}
            handleCertApprove={this.handleCertApprove}
            handleCertReject={this.handleCertReject}
            handleCancel={this.handleCancel}
            uploadFiles={this.uploadFiles}
            handleCourseCompleted={this.handleCourseCompleted}
            handleCourseNotCompleted={this.handleCourseNotCompleted}
            RejectToast={this.RejectToast}
            smallfocusRef={this.smallfocusRef}
            trainingBondRef={this.trainingBondRef}
            certificateRef={this.certificateRef}
            certificateExpiryDateApproval={
              this.state.certificateExpiryDateApproval
            }
            handleDateChange={(e) => this.handleDateChange(e)}
            AttachFiles={(e) => this.AttachFiles(e)}
          />
        </div>

        {/* End Screens for UserStatus.PENDING_TRAIN_BOND && Approval && Certificate Approval && Update Course Completion*/}

        {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

        {/* Screens for Pending for PTE1, PTE2, PTE3 Approval */}

        {
          <div
            className="offcanvas offcanvas-end offcanvas-pte"
            tabIndex={-1}
            data-bs-scroll="false"
            data-bs-backdrop="false"
            id="pteScreen"
            aria-labelledby="offcanvasScrollingLabel"
          >
            <BigCanvas
              pendingApprovalsView={pendingApprovalsView}
              currentUser={currentUser}
              courseQuestionaire={courseQuestionaire}
              LouDetails={LouDetails}
              validateComments={validateComments}
              isMobile={isMobile}
              pendingStatus={pendingStatus}
              isSmallMobile={isSmallMobile}
              inputValues={inputValues}
              isSMobile={isSMobile}
              isRadioMobile={isRadioMobile}
              uploadedFileName={this.state.uploadedFileName}
              isPdf={this.state.isPdf}
              isAgree={this.state.isAgree}
              isDontAgree={this.state.isDontAgree}
              certificateEndDate={this.state.certificateEndDate}
              TrainingBondComments={this.state.TrainingBondComments}
              postLOUAnswers={this.state.postLOUAnswers}
              historyLogList={historyLogList}
              closeProperties={this.closeProperties}
              fileNameAttachments={(e) => this.fileNameAttachments(e)}
              getEndDate={(e) => this.getEndDate(e)}
              handleTBondComments={this.handleTBondComments}
              handleApprove={this.handleApprove}
              handleReject={this.handleReject}
              handleCancel={this.handleCancel}
              handlePteApprove={(pteval) => this.handlePteApprove(pteval)}
              handlePteReject={this.handlePteReject}
              handleAgree={this.handleAgree}
              handleDontAgree={this.handleDontAgree}
              courseQuestApproval={this.courseQuestApproval}
              handlePteRadio={(e, questionId, radioAns, question, answerId) =>
                this.handlePteRadio(e, questionId, radioAns, question, answerId)
              }
              onChangeRadioValue={(
                event,
                questionId,
                question,
                id,
                name,
                index
              ) =>
                this.onChangeRadioValue(
                  event,
                  questionId,
                  question,
                  id,
                  name,
                  index
                )
              }
              handleLouInputchange={(
                e,
                questionId,
                index,
                question,
                LouDetails
              ) =>
                this.handleLouInputchange(
                  e,
                  questionId,
                  index,
                  question,
                  LouDetails
                )
              }
              postLOUEvaluation={this.postLOUEvaluation}
              postCourseEvaluation={this.postCourseEvaluation}
              updateAgreeState={this.updateAgreeState}
              RejectToast={this.RejectToast}
              focusRef={this.focusRef}
            />
          </div>
        }
        {/* End Screens for Pending for PTE1, PTE2, PTE3 Approval */}

        {/* Pending for Certificate Upload Screen */}

        <div
          className={` viewbar-search viewbarOpen visible-hide`}
          id="certificateUploadScreen"
        >
          <div className="viewMain">
            <div className="viewTitle mb-2 px-4 pt-4">
              <h6
                id="offcanvasRightLabel"
                className="modal-title head-span fw-600"
              >
                {pendingApprovalsView.pendingStatus
                  ? pendingApprovalsView.pendingStatus
                  : "-"}
              </h6>
              <button
                className={`text-reset offcavasclose buttonstyle ${
                  isMobile ? "pr-0" : ""
                }`}
                onClick={() => this.closeProperties()}
              >
                <CommonIcon fileName="CrossIcon" />
              </button>{" "}
            </div>
            <div className="px-4 pt-0" id="CertificateCanvas">
              <div className="row">
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                    isMobile ? "" : "pb-3"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon fileName="EmployeeCodeIcon" />
                      <span className="pl-5 text-12-bold">Employee code</span>
                    </label>
                    <label
                      className={`text-12-normal-400 ${
                        isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    >
                      {pendingApprovalsView.employeeCode
                        ? pendingApprovalsView.employeeCode
                        : "-"}
                    </label>
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                    isMobile ? "" : "pb-3"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon fileName="ContactPersonIcon" />
                      <span className="pl-5 text-12-bold">Employee name</span>
                    </label>
                    <label
                      className={`text-12-normal-400 ${
                        isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    >
                      {pendingApprovalsView.employeeName
                        ? pendingApprovalsView.employeeName
                        : "-"}
                    </label>
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                    isMobile ? "" : "pb-3"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon fileName="CourseCodeIcon" />
                      <span className="pl-5 text-12-bold">Course code</span>
                    </label>
                    <label
                      className={`text-12-normal-400 ${
                        isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    >
                      {pendingApprovalsView.courseCode
                        ? pendingApprovalsView.courseCode
                        : "-"}
                    </label>
                  </div>
                </div>
                <div
                  className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 ${
                    isMobile ? "" : "pb-3"
                  } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <div className="mt-3px">
                        <CommonIcon fileName="CourseTitleIcon" />
                      </div>{" "}
                      <span className="pl-7 text-12-bold">Course title</span>
                    </label>
                    <label
                      className={`text-12-normal-400 ${
                        isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    >
                      {pendingApprovalsView.courseTitle
                        ? pendingApprovalsView.courseTitle
                        : "-"}
                    </label>
                  </div>
                </div>

                {/* <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
                      <div className="">
                        <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                          <CommonIcon fileName="DateIcon" />
                          <span className="pl-5 text-12-bold">Requested date</span>
                        </label>
                        <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                          {pendingApprovalsView.requestedDate
                            ? moment(pendingApprovalsView.requestedDate).format(
                              "DD-MMM-YYYY"
                            )
                            : ""}
                        </label>
                      </div>
                    </div> */}
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                    isMobile ? "" : "pb-3"
                  } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon fileName="DateIcon" />{" "}
                      <span className="pl-5 text-12-bold">Requested date</span>
                    </label>
                    <label
                      className={`text-12-normal-400 ${
                        isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                    >
                      {pendingApprovalsView.requestedDate
                        ? moment(pendingApprovalsView.requestedDate).format(
                            "DD-MMM-YYYY"
                          )
                        : ""}
                    </label>
                  </div>
                </div>

                <div className="row">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon fileName="docAttach" />{" "}
                      <span className="pl-5 text-12-bold">
                        Attachments&nbsp;<span className="red-color">*</span>
                      </span>
                    </label>
                    <div
                      class={`input-group attach-style ${
                        isSmallMobile ? "mt-3 mb-2" : "mt-2"
                      }`}
                      style={{ borderColor: isFileEmpty ? "#d12232" : "" }}
                    >
                      <div class="d-flex w-100 filesHeight justify-content-evenly">
                        {/* <label class={`file-label-style ${uploadedFileName !== "" ? "file-select" : ""} `} aria-describedby="inputGroupFileAddon" >
                              {uploadedFileName !== "" && <>
                                <i className="FileIcon-img">
                                  {" "}
                                  {(isPdf) && <FileIcon fileName={uploadedFileName} />}
                                </i>
                                {(isPdf) && <span>{uploadedFileName}</span>}
                                {(uploadedFileName && isPdf) && <i className="mt-top" onClick={this.handleFileClose}><CommonIcon fileName="crossiconupload" /></i>}
                              </>
                              }

                              {
                                ((pendingApprovalsView.certificate?.fileId && pendingApprovalsView.certificate?.fileName) && <>
                                  <i className="FileIcon-img">
                                    {" "}
                                    {(isPdf) && <FileIcon fileName={pendingApprovalsView.certificate.fileName} />}
                                  </i>
                                  {(isPdf) && <span>{pendingApprovalsView.certificate.fileName}</span>}
                                  {(pendingApprovalsView.certificate.fileName && isPdf) && <i className="mt-top" onClick={this.handleFileClose}><CommonIcon fileName="crossiconupload" /></i>}
                                </>)
                              }


                            </label> */}

                        <label
                          class={`file-label-style ${
                            isPdf ? "file-select" : ""
                          } `}
                          aria-describedby="inputGroupFileAddon"
                        >
                          {((pendingApprovalsView.certificate?.fileId &&
                            pendingApprovalsView.certificate?.fileName) ||
                            uploadedFileName !== "") && (
                            <>
                              <i className="FileIcon-img">
                                {" "}
                                {isPdf && (
                                  <FileIcon
                                    fileName={
                                      uploadedFileName
                                        ? uploadedFileName
                                        : pendingApprovalsView.certificate
                                            .fileName
                                    }
                                  />
                                )}
                              </i>
                              {isPdf && (
                                <span>
                                  {uploadedFileName
                                    ? uploadedFileName
                                    : pendingApprovalsView.certificate.fileName}
                                </span>
                              )}
                              {(uploadedFileName
                                ? uploadedFileName
                                : pendingApprovalsView.certificate.fileName) &&
                                isPdf && (
                                  <i
                                    className="mt-top"
                                    onClick={this.handleFileClose}
                                  >
                                    <CommonIcon fileName="crossiconupload" />
                                  </i>
                                )}
                            </>
                          )}
                        </label>
                        <div
                          class="custom-file-input cursor-pointer"
                          onClick={() => this.HandleFileOpen("inputGroupFile1")}
                        >
                          <input
                            type="file"
                            id="inputGroupFile1"
                            onChange={(e) => {
                              this.fileNameAttachments(e);
                            }}
                            hidden
                            ref={this.certificateRef}
                          />
                          <i className="mt-2">
                            <CommonIcon fileName="upload" />
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isMobile ? "" : "pb-3 DatepadLeft"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text upload-bottom ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-5 text-12-bold">Expiry date</span>
                      </label>
                      {/* <TextField variant="outlined" size="small" fullWidth type="date" id="type-date"
                                                    InputProps={{ className: `border-radius f-size-12 date-icon` }} onChange={(e) => getEndDate(e)}
                                                    placeholder={certificateEndDate ? moment(certificateEndDate).format("DD-MMM-YYYY") : "dd-mmm-yyyy"}
                                                    value={certificateEndDate ? moment(certificateEndDate).format("yyyy-MM-DD") : "dd-mmm-yyyy"}
                                                    defaultValue=""
                                                /> */}

                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          minDate={
                            pendingApprovalsView.courseStartDate
                              ? new Date(pendingApprovalsView.courseStartDate)
                              : new Date()
                          }
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 mt-1"
                          // emptyLabel={certificateEndDate ? certificateEndDate : null}
                          keyboardIcon={
                            <CommonIcon
                              className="properties-img-2"
                              fileName="calenderDate"
                            />
                          }
                          emptyLabel="dd-mmm-yyyy"
                          format="dd-MMM-yyyy"
                          value={certificateEndDate ? certificateEndDate : null}
                          size="small"
                          onChange={(e) => this.getEndDate(e)}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>

                      {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              autoOk
                              minDate={new Date()}
                              variant="inline"
                              inputVariant="outlined"
                              className="form-control f-12 mt-1"
                              emptyLabel={certificateEndDate ? certificateEndDate : null}
                              keyboardIcon={
                                <CommonIcon className="properties-img-2" fileName="calenderDate" />
                              }
                              format="dd-MMM-yyyy"
                              value={certificateEndDate ? certificateEndDate : null}
                              size="small"
                              onChange={(e) => this.getEndDate(e)}
                              TextFieldComponent={({ value, onClick }) => (
                                <input
                                  value={value}
                                  onClick={onClick}
                                  readOnly
                                />
                              )}
                            />
                          </MuiPickersUtilsProvider> */}
                    </div>
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pb-3 mt-1`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon fileName="CommentIcon" />{" "}
                      <span className="pl-5 text-12-bold">Comments</span>
                    </label>
                    <textarea
                      className={`form-control border-radius shiptype-select mt-2 comments-style text-12-bold`}
                      id="small_Comments"
                      onChange={this.handleTBondComments}
                      style={{
                        borderColor: validateComments ? "#d12232" : "",
                      }}
                      value={TrainingBondComments}
                      ref={this.smallfocusRef}
                    />
                  </div>
                </div>
              </div>
              <button
                className={`btn approvebutton ml-0`}
                onClick={() => this.uploadFiles()}
              >
                <CommonIcon fileName="ButtonSubmitApprovalIcon" />
                Submit
              </button>
              {(currentUser?.includes(UserRole.ADMIN) ||
                currentUser?.includes(UserRole.SUPERVISOR) ||
                currentUser?.includes(UserRole.MANAGER) ||
                currentUser?.includes(UserRole.GM)) && (
                <div className="row mt-1">
                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="VersionIcon" />
                        <span className="pl-5 properties-span">
                          History log
                        </span>
                      </label>
                      <div className="table-responsive table-responsive-scroll mb-4 mt-3">
                        <table id="historyTable">
                          <tbody>
                            {historyLogList?.length !== 0 ? (
                              historyLogList?.map((i, index) => (
                                <>
                                  <tr id={index} key={index}>
                                    <td className="title-width fw-bold">
                                      {i.status}
                                    </td>
                                    <td
                                      className={`history-date no-wrap ${
                                        isRadioMobile ? "date-width" : ""
                                      }`}
                                    >
                                      {i.createdDate
                                        ? moment(
                                            new Date(Date.parse(i.createdDate))
                                          ).format("DD-MMM-YYYY h:mm A")
                                        : ""}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2} className="fw-bold">
                                      {" "}
                                      {i.reviewer}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2} className="history-comment">
                                      {i.comments}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td className="table-noversion" colSpan={3}>
                                  No history log to display
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ////////////////////////////////////////////////////////////////////////////////////////////////// */}

        {
          // <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchScreen" aria-labelledby="offcanvasScrollingLabel">
          //   <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>

          //     <h6 id="offcanvasRightLabel" className="modal-title head-span">Search</h6>

          //     <button className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""}`} onClick={() => this.closeProperties()}>
          //       <CommonIcon fileName="CrossIcon" />
          //     </button>{" "}
          //   </div>
          <div
            className={` viewbar-search viewbarOpen display-hide`}
            id="searchScreen"
          >
            <div className="viewMain">
              <div className="viewTitle mb-2 px-4 pt-4">
                <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                  Search
                </h6>
                <button
                  className={`text-reset offcavasclose buttonstyle ${
                    isMobile ? "pr-0" : ""
                  }`}
                  onClick={() => this.clearSearchProperties()}
                >
                  <CommonIcon fileName="CrossIcon" />
                </button>
              </div>

              <div className="px-4 pt-0">
                <div className="row">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="requestId" />
                        <span className="pl-5 properties-span-2">
                          Request ID
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box-search  records-editinput-class "
                        value={this.state.searchInputData.trainingRequestId}
                        onChange={(e) =>
                          this.handleInputchange(e, "trainingRequestId")
                        }
                        required
                      />
                    </div>
                  </div>

                  {(currentUser?.includes(UserRole.ADMIN) ||
                    currentUser?.includes(UserRole.SUPERVISOR) ||
                    currentUser?.includes(UserRole.MANAGER) ||
                    currentUser?.includes(UserRole.GM)) && (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                          isMobile ? "" : "pb-3"
                        }`}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex mb-1 label-text ${
                              isMobile ? "pt-2" : ""
                            }`}
                          >
                            <CommonIcon fileName="VendorNameIcon" />
                            <span className="pl-5 properties-span-2 ">
                              Employee code
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-text-box-search  records-editinput-class"
                            value={this.state.searchInputData.employeeCode}
                            onChange={(e) =>
                              this.handleInputchange(e, "employeeCode")
                            }
                            required
                          />
                        </div>
                      </div>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                          isMobile ? "" : "pb-3"
                        } `}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex mb-1 label-text ${
                              isMobile ? "pt-2" : ""
                            }`}
                          >
                            <CommonIcon fileName="ContactPersonIcon" />
                            <span className="pl-7 properties-span-2">
                              Employee name
                            </span>
                          </label>
                          <Select
                            className={`form-text-box-search ${
                              this.state.employeeNameEmpty && "border-red"
                            }  `}
                            classNamePrefix="assigngroups"
                            value={this.state.selectEmployeeName}
                            placeholder="Please select an option"
                            styles={styles}
                            options={this.state.employeeNameList}
                            defaultValue={
                              this.state.selectEmployeeName || "Select"
                            }
                            menuPosition="fixed"
                            menuPlacement="auto"
                            isClearable={true}
                            isMulti={false}
                            isSearchable={true}
                            onChange={this.onchangeEmployeeName}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="CourseCodeIcon" />
                        <span className="pl-5 properties-span-2">
                          Course code
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box-search  records-editinput-class"
                        value={this.state.searchInputData.courseCode}
                        onChange={(e) =>
                          this.handleInputchange(e, "courseCode")
                        }
                        required
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-1 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="CourseTitleIcon" />
                        <span className="pl-5 properties-span-2">
                          Course title
                        </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.courseTitle}
                        onChange={(e) =>
                          this.handleInputchange(e, "courseTitle")
                        }
                        required
                      />
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${
                      isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-2 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">
                          Requested date
                        </span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 records-editinput-class"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={<CommonIcon fileName="calenderDate" />}
                          format="dd-MMM-yyyy"
                          value={
                            this.state.searchInputData.requestedDate
                              ? this.state.searchInputData.requestedDate
                              : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleInputchange(e, "requestedDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${
                      isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="PropertiesIcon" />
                        <span className="pl-5 properties-span-2">
                          Current status
                        </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.currentStatus}
                        onChange={(e) =>
                          this.handleInputchange(e, "currentStatus")
                        }
                        required
                      />
                    </div>
                  </div>
                </div>

                {this.state.validationMsg ? (
                  <span className="properties-span-2 text-danger">
                    Atleast one field is mandatory
                  </span>
                ) : (
                  ""
                )}

                <div className="d-flex mt-20">
                  <button
                    className={`btn rejectbutton d-flex gap-1`}
                    onClick={() => this.clearSearchDetails()}
                  >
                    <span>
                      <CommonIcon fileName="clearIcon1" />
                    </span>
                    <span className="pl-vendor3 pl-2">Clear</span>
                  </button>
                  <button
                    className={`btn approvebutton d-flex gap-1 ml-10 `}
                    onClick={() => this.validateSearchRecords()}
                  >
                    <span className="">
                      <CommonIcon fileName="searchableIcon" />
                    </span>
                    <span className="model-label pl-vendor3 pl-2">Search</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

        <WarningComponent
          message={
            ((pendingStatus === UserStatus.PENDING_FOR_APPROVAL ||
              pendingStatus === UserStatus.PENDING_FOR_ADMIN_APPROVAL ||
              pendingStatus === UserStatus.PENDING_FOR_GM_APPROVAL ||
              pendingStatus === UserStatus.PENDING_FOR_MANAGER_APPROVAL ||
              pendingStatus === UserStatus.PENDING_FOR_SUPERVISOR_APPROVAL ||
              pendingStatus === UserStatus.PENDING_FOR_CERT) &&
              "Are you sure you want to reject the request?") ||
            (pendingStatus?.includes("pte") &&
              "Are you sure you want to reject the PTE request?") ||
            ((pendingStatus ===
              UserStatus.PENDING_REVIEW_COURSE_QUESTIONNAIRE ||
              pendingStatus === UserStatus.PENDING_TRAIN_BOND) &&
              "Are you sure you want to cancel the request?")
          }
          isMobile={this.state.isMobile}
          onYesClick={() => this.handleRejectPopup()}
        />

        {/* Pagination */}
        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={this.state.totalCount}
          reset={this.state.pageNewCount}
        />
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}
function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PendingSubmissions)
);
